import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

//general
import PrivateRoute from './components/PrivateRoute';
import Inbox from './screens/mainPages/Inbox';

const ConnectRoutes = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <Routes>

      <Route
        path="/inbox"
        element={
          <PrivateRoute
            permission={['ADMIN', 'MANAGER', 'STANDARD', 'OWNER', 'PERSONAL']}
          >
            <Inbox />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default ConnectRoutes;
